let selectedProducts = [];
let maxBoxItems = 6; // Maximum items in the box
let selectedNumber = null;
let totalAmount = 0;
const data = {
    4: 'build-a-pack-4-pack',
    8: 'build-a-pack-8-pack',
    12: 'build-a-pack-12-pack'
};


let products = []; // Declare an empty array to hold product data

function setProducts(productData) {
    products = productData; // Assign fetched product data to the products array

}
// Get the current time in the user's local timezone
const now = new Date();

// Create a date object for midnight UK time (00:00) today in the user's local timezone
const targetDate = new Date();

// Set the target time to 12:00 AM (midnight) in the UK (GMT/BST)
// Create a target midnight time in the UK timezone (UTC+0)
targetDate.setUTCHours(24, 0, 0, 0); // Sets target time to midnight of the current day in UTC

// Adjust the target date to the next midnight if it's already past midnight in the user's time zone
if (now > targetDate) {
    targetDate.setUTCDate(targetDate.getUTCDate() + 1); // Set target to the next midnight
}

// Function to update the timer
function updateTimer() {
    const now = new Date();
    const timeDifference = targetDate - now;

    // Select the container with aria-label "countdown-timer"
    const countdownContainers = document.querySelectorAll('[aria-label="countdown-timer"]');

    if (timeDifference <= 0) {
        countdownContainers.forEach(container => {
            container.textContent = "Time's up!";
        });
        return;
    }

    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDifference / 1000) % 60);

    // Update elements with aria-labels
    document.querySelectorAll('[aria-label="hours"]').forEach(el => {
        el.textContent = String(hours).padStart(2, '0');
    });
    document.querySelectorAll('[aria-label="minutes"]').forEach(el => {
        el.textContent = String(minutes).padStart(2, '0');
    });
    document.querySelectorAll('[aria-label="seconds"]').forEach(el => {
        el.textContent = String(seconds).padStart(2, '0');
    });
}

// Update the timer every second
setInterval(updateTimer, 1000);

// Initialize the timer
updateTimer();



function randomizeProducts() {
    const products = [
        {
        productId: 9647257846040,
        productName: "PISTACHIO KUNAFA",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys13_886cf52e-f103-43bd-b2ab-37c9cdd89f71_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708892979480,
        prodHandle: "pistachio-kunafa"
    },
    {
        productId: 9591075701016,
        productName: "YOU’RE SO JAMMY",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys5a_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49459924107544,
        prodHandle: "bunos-dias"
    },
    {
        productId: 9647258304792,
        productName: "BUTTER ME UP",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys12_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708898287896,
        prodHandle: "butter-me-up"
    },
    {
        productId: 9647258140952,
        productName: "WE FOUND NEMO",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys15_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708897304856,
        prodHandle: "we-found-nemo"
    },
    {
        productId: 9647257583896,
        productName: "KEITH LEMON",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys10a_0599552b-a3fa-4e5f-887d-df12adef19b6_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708891898136,
        prodHandle: "keith-lemon"
    },
    {
        productId: 9647257223448,
        productName: "BLOOMIN ‘ELL",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys8_400x400.jpg?v=1738342319",
        price: 1400,
        variantId: 49708888424728,
        prodHandle: "bloomin-ell"
    },
    {
        productId: 9647254962456,
        productName: "THE ROYAL MINT",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys4_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708825084184,
        prodHandle: "the-royal-mint"
    },
    {
        productId: 9647254569240,
        productName: "JAMES BROWNIE",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys1a_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708823609624,
        prodHandle: "james-brownie"
    },
    {
        productId: 9647254176024,
        productName: "A PIECE OF REECE",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys14a_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708820562200,
        prodHandle: "a-piece-of-reece"
    },
    {
        productId: 9647251685656,
        productName: "BUENOS DIAS",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys9a_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49708812009752,
        prodHandle: "you-re-so-jammy"
    },
    {
        productId: 9591075602712,
        productName: "HASTA LA PISTA",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys13_400x400.jpg?v=1736318026",
        price: 295,
        variantId: 49459923943704,
        prodHandle: "hasta-la-pisat"
    },
    {
        productId: 9591075438872,
        productName: "PINKY AND THE BRAIN",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys2acorrected_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49459923419416,
        prodHandle: "pinky-and-the-brain"
    },
    {
        productId: 9591075111192,
        productName: "RITA OREO",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys6_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49459921420568,
        prodHandle: "rita-orea"
    },
    {
        productId: 9591070195992,
        productName: "TAKING THE BISCUIT",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys3a_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49459914178840,
        prodHandle: "taking-the-biscuit"
    },
    {
        productId: 9591065182488,
        productName: "THE NUTTY PROFESSOR",
        productImage: "//buildthebox.myshopify.com/cdn/shop/files/SammosaBoys11a_314a9b9d-a7a4-4d4d-b504-210329eca409_400x400.jpg?v=1738342195",
        price: 1400,
        variantId: 49459901858072,
        prodHandle: "the-nutty-professor"
    }
    ];

    const times = maxBoxItems; // Number of times to add random products

    for (let i = 0; i < times; i++) {
        const randomProduct = products[Math.floor(Math.random() * products.length)];

        console.log(`Adding ${randomProduct.productName} to the box - Attempt ${i + 1}`);
        addToBox(
            randomProduct.productId,
            randomProduct.productName,
            randomProduct.productImage,
            randomProduct.price,
            randomProduct.variantId,
            randomProduct.prodHandle
        );
    }
}

// Call the function to add random products



window.onload = function() {

    const element = document.querySelector('[aria-label="Edit Selection"]');
    element.style.display = "none";




    if(!isBoxLimitSet())
        setBoxLimit(8,false); // Set your default box limit here (e.g., 2, 6, or 8)
};

function setBoxLimit(limit, wantLoad) {
    if (![4, 8, 12].includes(limit)) {
        alert("Invalid box limit. Please choose 4, 8, or 12.");
        return;
    }
  
  

    const isSmallerThanOrEqualSm = window.matchMedia("(max-width: 768px)").matches;
    if (isSmallerThanOrEqualSm){
        document.getElementById('box-item-list-wrapper').style.display = "none";
        
      
    }


  
 
  
    document.getElementById('bap-review').classList.add('pack-preview-closed');

    maxBoxItems = limit; // Set the box limit to the chosen value
    clearBox(wantLoad); // Clear the box for a new selection
    setStaticProduct(limit); // Set the selected product ID in the hidden input field

    localStorage.setItem("selectedBoxLimit", limit);

    // Select the ul element with the id "numberList" and remove 'selected' class from its li children
    const numberListEl = document.getElementById("numberList"); // Fixed name conflict
    if (numberListEl) {
        numberListEl.querySelectorAll(".selected").forEach(li => li.classList.remove("selected"));
    }

    // Add the 'selected' class to the specific li element corresponding to the selected limit
    const selectedLi = document.getElementById(`li-${limit}`);
    if (selectedLi) {
        selectedLi.classList.add("selected");
    }
}

//IDHAR PRODUCT UTHAYA JA RAHA HAI
function boxSlotWidth(limit) {
    const boxSelection = document.getElementById('box-selection'); // Ensure this ID exists
    const boxSlots = document.querySelectorAll('.box-slot'); // Select all box-slot elements

    if (!boxSelection || boxSlots.length === 0) return; // Prevent errors if elements are missing

    

    // Update .box-slot styles dynamically
    boxSlots.forEach(slot => {
        if (limit === 8) {
            slot.style.flex = "1 1 calc(100% / 4 - 10px)";
            slot.style.maxWidth = "calc(100% / 4 - 10px)";
        } else {
            slot.style.flex = "1 1 calc(100% / 6 - 10px)";
            slot.style.maxWidth = "calc(100% / 6 - 10px)";
        }
    });
}


async function setStaticProduct(limit) {
    try {
        // Await the fetch and make sure you parse the response as JSON
        const response = await fetch(`${window.Shopify.routes.root}products/${data[limit]}.js`);
        
        // Check if the response is ok
        if (!response.ok) {
            throw new Error(`Failed to fetch product data for ${data[limit]}`);
        }

        // Parse the JSON response
        const productData = await response.json();
        
        // Call the function to update the total price with the variant's price
        setAmountToTotal(productData.variants[0].price);
        // Set the selected product ID in the hidden input field
        document.getElementById("static-product").value = productData.variants[0].id;
    } catch (error) {
        console.error('Error:', error);
    }
}


// Function to set the stored limit
function setStoredLimit(wantLoad) {
    const storedLimit = localStorage.getItem("selectedBoxLimit");
    if (storedLimit) {
        // Convert to number and call setBoxLimit
        setBoxLimit(Number(storedLimit), wantLoad);
    }
}

// Call setStoredLimit when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
    setStoredLimit(false); // Pass `false` as wantLoad
});

function addToBox(productId, productName, productImage,price,variantId,prodHandle) {
  console.log("Adding product to box with the following details:");
    console.log("Product ID:", productId);
    console.log("Product Name:", productName);
    console.log("Product Image:", productImage);
    console.log("Price:", price);
    console.log("Variant ID:", variantId);
    console.log("Product Handle:", prodHandle);
        
    let productVal = document.getElementById(`quantity-${productId}`).value;

    document.getElementById('bap-review').classList.remove('pack-preview-closed');

    document.getElementById('box-item-list-wrapper').style.removeProperty('display');


    if (selectedProducts.length >= maxBoxItems) {
        return;
    }

    //addAmountToTotal(price);

    if(productVal < 1){
        document.getElementById(`bap-doughnut_${productId}`).style.display = 'block';
        document.getElementById(`add-btn-${productId}`).style.display = 'none';
        document.getElementById(`quantity-${productId}`).value = 1;
    }



    selectedProducts.push({ id: productId, name: productName, image: productImage,varId:variantId,handle:prodHandle });
    const namesArray = selectedProducts.map(item => item.name);
    updateStaticProductProperties(namesArray);


    if(selectedProducts.length >= maxBoxItems) {
        document.getElementById("number-selection").style.display = "block";
        document.getElementById("box-selections-funcs").style.display = "none";
        document.getElementById("add-to-cart").style.display = "block";

        const isSmallerThanOrEqualSm = window.matchMedia("(max-width: 786px)").matches;

        if(isSmallerThanOrEqualSm){
            document.getElementById('bap-review').classList.add('open');
            const element = document.querySelector('[aria-label="Edit Selection"]');
            element.style.removeProperty('display');
        }


    }

    updateBoxUI();

    
}


function addAmountToTotal(price) {
    totalAmount += (price / 100);
    // console.log("Total Amount: " , totalAmount);
    // console.log("Price: " , price);
    document.getElementById('bap-pack-price-preview').innerHTML = `£${totalAmount}`;
}
function setAmountToTotal(price) {
    totalAmount = (price / 100);
    // console.log("Total Amount: " , totalAmount);
    // console.log("Price: " , price);
    document.getElementById('bap-pack-price-preview').innerHTML = `£${totalAmount}`;
}


function clearBox(wantLoad) {
    selectedProducts = [];
    selectedNumber = null;
    updateStaticProductProperties([]);
    document.getElementById("number-selection").style.display = "none";
    document.getElementById("additional-info").style.display = "none";
    document.getElementById("box-selections-funcs").style.display = "block";

    updateBoxUI();

    if(wantLoad)
        location.reload();

}


function updateBoxUI() {
    const boxItemsList = document.getElementById("boxItemsList");
    boxItemsList.innerHTML = ""; // Clear the list

    for (let i = 0; i < maxBoxItems; i++) {
        const item = document.createElement("li");
        item.className = "rounded-3xl box-slot ";

        if (selectedProducts[i]) {
            // Product slot
            item.innerHTML = `
                <div class="product-item w-full h-full" onmouseover="showRemoveIcon(this)" onmouseout="hideRemoveIcon(this)">
                    <img src="${selectedProducts[i].image}" alt="${selectedProducts[i].name}" class="rounded-3xl product-image h-full" />
<!--                    <svg  xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20" fill="none" style="margin: 4px; padding: 5px; display: flex; align-items: center; justify-content: center;" >-->
<!--                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#FFFFFF"></path>-->
<!--                        </svg>-->
                    <div onclick="decreaseQuantity(${selectedProducts[i].id})" id="remove-doughnut-0" x-transition="" class="remove-icon bap-remove-selected-doughnut cursor-pointer" data-doughnut-id="doughnut_JBVbGX" x-show="show" style="display: none; opacity: 1; transform: scale(1); transform-origin: center center; transition-property: opacity, transform; transition-duration: 0.075s; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" style="position: relative;margin: 4px 4px;">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#FFFFFF"></path>
                        </svg>
                     </div>
<!--                    <span class="remove-icon" >×</span>-->
                </div>
            `;
        } else {
            // Placeholder slot
            item.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0901/2340/3544/files/samosa-icon.png?v=1731504729" alt="Placeholder" class="rounded-3xl placeholder-image" />`;
        }

        boxItemsList.appendChild(item);
    }
}


function removeProduct(index) {
    // if(selectedProducts.length <= 1 )
    //     document.getElementById('bap-review').classList.remove('pack-preview-closed');


    if(selectedProducts.length >= maxBoxItems){
        document.getElementById("number-selection").style.display = "none";
        document.getElementById("additional-info").style.display = "none";
        document.getElementById("box-selections-funcs").style.display = "block";
        document.getElementById("add-to-cart").style.display = "none";
        document.getElementById('bap-review').classList.remove('open');
        document.querySelector('[aria-label="Edit Selection"]').style.display="none";

    }
    selectedProducts.splice(index, 1);
    const namesArray = selectedProducts.map(item => item.name);
    updateStaticProductProperties(namesArray);

    updateBoxUI();
}

// Functions to show and hide the remove icon
function showRemoveIcon(item) {
    item.querySelector(".remove-icon").style.display = "flex";
}

function hideRemoveIcon(item) {
    item.querySelector(".remove-icon").style.display = "none";
}

var cardPrice = 0;
var cardProduct = null;

function selectNumber(variantId,price) {
    if(variantId != null){
        
        console.log(price);
        // selectedNumber = number;
        cardPrice = price;
        // console.log(price);
        addAmountToTotal(cardPrice);
        // cardProduct = {price,variantId};
        document.getElementById("gift-card-id").value = variantId.toString();
        document.getElementById("additional-info").style.display = "block";
        document.getElementById("number-selection").style.display = "none";
    }
}

function selectCard(){

    // selectedNumber = 0;
    addAmountToTotal(-cardPrice);
    cardPrice = 0;
    // cardProduct = null;
    document.getElementById("gift-card-id").value = "";

    document.getElementById("additional-info").style.display = "none";
    document.getElementById("number-selection").style.display = "block";
}



function removeLast(){
    decreaseQuantity(selectedProducts[selectedProducts.length-1].id);
}



// Function to increase quantity
function increaseQuantity(id) {

    if(selectedProducts.length >= maxBoxItems){
        return;
    }
    const quantityInput = document.getElementById(`quantity-${id}`);
    let quantity = parseInt(quantityInput.value);
    quantity++;
    quantityInput.value = quantity;
}

// Function to decrease quantity
function decreaseQuantity(id) {
    const quantityInput = document.getElementById(`quantity-${id}`);
    let quantity = parseInt(quantityInput.value);

    if (quantity > 1) {
        quantity--;
        quantityInput.value = quantity;
    } else {
        // If quantity is 0, hide quantity div and show Add button
        quantityInput.value = 0;
        document.getElementById(`bap-doughnut_${id}`).style.display = 'none';
        document.getElementById(`add-btn-${id}`).style.display = 'block';
    }

    for (var i = 0 ; i < selectedProducts.length ; i++){
        if(selectedProducts[i].id == id){
            removeProduct(i);
            break;
        }
    }
}

// Function to check if the box limit is set in localStorage
function isBoxLimitSet() {
    const storedLimit = localStorage.getItem("selectedBoxLimit");
    return storedLimit !== null; // Returns true if the limit is set, false otherwise
}

document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.getElementById('toggle-button');
    const deliveryDetails = document.getElementById('delivery-details');

    toggleButton.addEventListener('click', function () {
        const isOpen = deliveryDetails.style.maxHeight && deliveryDetails.style.maxHeight !== '0px';
        deliveryDetails.style.maxHeight = isOpen ? '0' : '500px'; // Adjust 500px to fit your content's height
        toggleButton.setAttribute('aria-expanded', !isOpen);
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.getElementById('toggle-button-2');
    const deliveryDetails = document.getElementById('delivery-details-2');

    toggleButton.addEventListener('click', function () {
        const isOpen = deliveryDetails.style.maxHeight && deliveryDetails.style.maxHeight !== '0px';
        deliveryDetails.style.maxHeight = isOpen ? '0' : '500px'; // Adjust 500px to fit your content's height
        toggleButton.setAttribute('aria-expanded', !isOpen);
    });
});


// event listener for the gift card message input
document.addEventListener("DOMContentLoaded", function () {
    const messageBox = document.getElementById("greeting-card-message");
    const charsLeftElement = document.querySelector(".gift-message-chars-left");
  
    // Handle the 'onchange' and 'onkeyup' events
    messageBox.addEventListener("input", function () {
      const remainingChars = 200 - this.value.length;
      charsLeftElement.textContent = remainingChars;
  
      // Update the gift card message dynamically (if required elsewhere in the app)
      updateGiftCardMessage(this.value);
    });
  
    // Function to update the gift card message
    function updateGiftCardMessage(message) {
      document.getElementById("gift-card-message").value = message;
      // Add additional logic here to handle the updated message, e.g., sending it to a hidden field
    }
  });


  // Function to update static product properties
//function updateStaticProductProperties(products) {
    // Sort product names to ensure canonical order
    //const sortedProducts = products.sort().join(", ");
    //document.getElementById("static-product-properties").value = sortedProducts;
//  }
  function updateStaticProductProperties(products) {
    // Count occurrences of each product
    const productCounts = products.reduce((acc, product) => {
        acc[product] = (acc[product] || 0) + 1;
        return acc;
    }, {});

    // Format as "Product Name (Quantity)"
    const formattedProducts = Object.entries(productCounts)
        .map(([product, count]) => `${product} (${count})`)
        .join(", ");

    // Set formatted value in hidden input
    document.getElementById("static-product-properties").value = formattedProducts;

    // Log to console for debugging
    console.log("Formatted Order Items:", formattedProducts);
}


// in case no card is selected
  document.getElementById('dynamic-cart-form').addEventListener('submit', function(event) {
    // Check if the gift card ID is empty
    var giftCardId = document.getElementById('gift-card-id').value;

    // If the gift card ID is empty, remove the gift card fields from the form
    if (!giftCardId) {
      // Remove the gift card properties from the form data
      document.getElementById('gift-card-id').remove();
      document.getElementById('gift-card-message').remove();
    }
  });
